import React from 'react';
import { Button } from '../atoms/Button';
import { ThemeToggle } from '../atoms/ThemeToggle';
import { useTheme } from '../../contexts/ThemeContext';

const NAV_LINKS = [
  { href: '#home', label: 'Home', id: 'home' },
  { href: '#about', label: 'About', id: 'about' },
  { href: '#services', label: 'Services', id: 'services' },
  { href: '#resume', label: 'Resume', id: 'resume' },
  { href: '#work', label: 'Work', id: 'work' },
  { href: '#contact', label: 'Contact', id: 'contact' },
] as const;

type HeaderProps = {
  resumePdfUrl: string;
  activeSectionId?: string;
};

export function Header({ resumePdfUrl, activeSectionId = 'home' }: HeaderProps) {
  const { theme, toggleTheme } = useTheme();

  return (
    <header
      className="sticky top-0 z-50 border-b border-stone-200/80 bg-white/80 backdrop-blur-md dark:border-stone-700 dark:bg-stone-900/80"
      role="banner"
    >
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-4 px-4 py-3">
        <span className="font-display text-lg font-semibold text-stone-800 dark:text-stone-100">
          Alex Appadurai
        </span>
        <nav
          className="flex flex-wrap items-center justify-end gap-1 sm:gap-2"
          aria-label="Main navigation"
        >
          {NAV_LINKS.map(({ href, label, id }) => {
            const isActive = activeSectionId === id;
            return (
              <a
                key={href}
                href={href}
                className={`rounded-lg px-3 py-2 text-sm font-medium transition-colors hover:bg-stone-100 hover:text-stone-900 dark:hover:bg-stone-700 dark:hover:text-stone-100 ${
                  isActive
                    ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/50 dark:text-emerald-300'
                    : 'text-stone-600 dark:text-stone-400'
                }`}
                aria-current={isActive ? 'location' : undefined}
              >
                {label}
              </a>
            );
          })}
          <ThemeToggle theme={theme} onToggle={toggleTheme} />
          <Button
            href={resumePdfUrl}
            variant="outline"
            className="ml-2"
            aria-label="Download resume PDF"
          >
            Download resume
          </Button>
        </nav>
      </div>
    </header>
  );
}
